var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content telephonyAccess" }, [
    _vm.users
      ? _c("div", { staticClass: "card" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "card-body" }, [
            _c(
              "div",
              { staticClass: "flex flex-wrap users_radio_block" },
              _vm._l(_vm.users, function (user) {
                return user.is_active
                  ? _c("div", { key: user.id }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.selectedUser,
                            expression: "selectedUser",
                          },
                        ],
                        staticClass: "btn-check hidden",
                        attrs: {
                          type: "radio",
                          name: "selected_user",
                          id: `u_${user.id}`,
                          autocomplete: "off",
                        },
                        domProps: {
                          value: user,
                          checked: _vm._q(_vm.selectedUser, user),
                        },
                        on: {
                          change: function ($event) {
                            _vm.selectedUser = user
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "btn btn-primary",
                          attrs: { for: `u_${user.id}` },
                        },
                        [
                          _vm._v(
                            _vm._s(user.name) +
                              " (" +
                              _vm._s(user.id) +
                              ") -\n            [" +
                              _vm._s(_vm.getActivePhonesByUser(user)) +
                              "]"
                          ),
                        ]
                      ),
                    ])
                  : _vm._e()
              }),
              0
            ),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c("h5", [_vm._v("Смены")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex flex-wrap users_radio_block" },
              _vm._l(_vm.shifts, function (g) {
                return g.is_active
                  ? _c("div", { key: `group_${g.id}` }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.selectedGroup,
                            expression: "selectedGroup",
                          },
                        ],
                        staticClass: "btn-check hidden",
                        attrs: {
                          type: "radio",
                          name: "selected_shift",
                          id: g.id,
                          autocomplete: "off",
                        },
                        domProps: {
                          value: g,
                          checked: _vm._q(_vm.selectedGroup, g),
                        },
                        on: {
                          change: function ($event) {
                            _vm.selectedGroup = g
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "btn btn-primary",
                          attrs: { for: g.id },
                        },
                        [_vm._v(_vm._s(g.title) + " (" + _vm._s(g.id) + ")")]
                      ),
                    ])
                  : _vm._e()
              }),
              0
            ),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "card" }, [
      _c(
        "form",
        {
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.search()
            },
          },
        },
        [
          _c("div", { staticClass: "card-body flex search_blocks" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", { attrs: { for: "" } }, [_vm._v("Номер")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.searchData.phone,
                    expression: "searchData.phone",
                  },
                ],
                staticClass: "form-control",
                attrs: { type: "text", placeholder: "Номер телефона" },
                domProps: { value: _vm.searchData.phone },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.searchData, "phone", $event.target.value)
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "flex btns" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-default align-self-end",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.search(true)
                    },
                  },
                },
                [_vm._v("Сбросить")]
              ),
            ]),
            _vm._v(" "),
            _vm._m(1),
          ]),
        ]
      ),
    ]),
    _vm._v(" "),
    _vm.searchResult
      ? _c("div", { staticClass: "card" }, [
          _c(
            "div",
            { staticClass: "card-body" },
            [
              !_vm.searchRecords ||
              (_vm.searchRecords && !_vm.searchRecords.length)
                ? [_c("p", [_vm._v("Не надены телефоны")])]
                : [
                    _c("table", { staticClass: "table-hover table table-sm" }, [
                      _c(
                        "tbody",
                        _vm._l(_vm.searchRecords, function (record, index) {
                          return _c("tr", [
                            _c("td", [_vm._v(_vm._s(index + 1))]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(record.display_phone))]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(record.description))]),
                            _vm._v(" "),
                            _c("td", [
                              _vm.$AllProjects &&
                              _vm.$AllProjects[record.site_id]
                                ? _c("p", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$AllProjects[record.site_id].name
                                      ) +
                                        " -\n                " +
                                        _vm._s(
                                          _vm.$AllProjects[record.site_id].title
                                        )
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.$AllCities && _vm.$AllCities[record.city_id]
                                ? _c("p", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$AllCities[record.city_id]
                                          .short_name
                                      ) +
                                        " -\n                " +
                                        _vm._s(
                                          _vm.$AllCities[record.city_id].name
                                        )
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _c(
                              "td",
                              _vm._l(
                                _vm.getUsersByPhone(record.phone),
                                function (user) {
                                  return _c(
                                    "p",
                                    {
                                      staticClass: "pointer btn-link",
                                      on: {
                                        click: function ($event) {
                                          return _vm.showUser(user, record.id)
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(user.name))]
                                  )
                                }
                              ),
                              0
                            ),
                          ])
                        }),
                        0
                      ),
                    ]),
                  ],
            ],
            2
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    (_vm.selectedUser || _vm.selectedGroup) && !_vm.searchResult
      ? _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card-header" }, [
            _c("h5", [
              _vm._v(
                _vm._s(
                  (_vm.selectedUser && _vm.selectedUser.name) ||
                    (_vm.selectedGroup && _vm.selectedGroup.title)
                ) + "\n        "
              ),
              _c(
                "span",
                { staticClass: "pull-right" },
                [
                  _c(
                    "vue-ladda",
                    {
                      attrs: {
                        "button-class": "btn btn-sm btn-success",
                        "data-style": "zoom-in",
                        loading: _vm.saveLoading,
                      },
                      on: { click: _vm.updateUser },
                    },
                    [_vm._v("Сохранить\n            ")]
                  ),
                ],
                1
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card-body" }, [
            _vm.phones
              ? _c("div", [
                  _c("table", { staticClass: "table table-sm table-hover" }, [
                    _c("thead", [
                      _c("tr", [
                        _c("th"),
                        _vm._v(" "),
                        _c("th"),
                        _vm._v(" "),
                        _c("th"),
                        _vm._v(" "),
                        _c("th", { staticClass: "text-right" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-default mb-3",
                              on: {
                                click: function ($event) {
                                  return _vm.updateFilter(true)
                                },
                              },
                            },
                            [_vm._v("Сбросить")]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("th", [
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v("Проект"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.filter.site_id,
                                    expression: "filter.site_id",
                                  },
                                ],
                                staticClass: "form-control",
                                on: {
                                  change: [
                                    function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.filter,
                                        "site_id",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    },
                                    function ($event) {
                                      return _vm.updateFilter(false)
                                    },
                                  ],
                                },
                              },
                              [
                                _c("option", { attrs: { value: "0" } }, [
                                  _vm._v("Все проекты"),
                                ]),
                                _vm._v(" "),
                                _vm._l(_vm.$AllProjects, function (project) {
                                  return project.id && project.is_active
                                    ? _c(
                                        "option",
                                        { domProps: { value: project.id } },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(project.name) +
                                              "\n                  "
                                          ),
                                        ]
                                      )
                                    : _vm._e()
                                }),
                              ],
                              2
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("th", [
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v("Город"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.filter.city_id,
                                    expression: "filter.city_id",
                                  },
                                ],
                                staticClass: "form-control",
                                on: {
                                  change: [
                                    function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.filter,
                                        "city_id",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    },
                                    function ($event) {
                                      return _vm.updateFilter(false)
                                    },
                                  ],
                                },
                              },
                              [
                                _c("option", { attrs: { value: "0" } }, [
                                  _vm._v("Любой город"),
                                ]),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.sortArray(
                                    Object.values(_vm.$AllCities),
                                    "name"
                                  ),
                                  function (city) {
                                    return _c(
                                      "option",
                                      { domProps: { value: city.id } },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(city.name) +
                                            "\n                  "
                                        ),
                                      ]
                                    )
                                  }
                                ),
                              ],
                              2
                            ),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("th"),
                        _vm._v(" "),
                        _c("th", [
                          _c("input", {
                            attrs: { type: "checkbox", name: "" },
                            on: { change: _vm.updateSelectedPhones },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Телефон")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Описание")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Сайт")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Город")]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.phones, function (phone, index) {
                        return _c(
                          "tr",
                          {
                            key: phone.id,
                            class: { selected: phone.searchSelected },
                          },
                          [
                            _c("td", [_vm._v(_vm._s(index + 1))]),
                            _vm._v(" "),
                            _c("td", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.selectedPhones[phone.id],
                                    expression: "selectedPhones[phone.id]",
                                  },
                                ],
                                attrs: { type: "checkbox" },
                                domProps: {
                                  checked: Array.isArray(
                                    _vm.selectedPhones[phone.id]
                                  )
                                    ? _vm._i(
                                        _vm.selectedPhones[phone.id],
                                        null
                                      ) > -1
                                    : _vm.selectedPhones[phone.id],
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = _vm.selectedPhones[phone.id],
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.selectedPhones,
                                            phone.id,
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.selectedPhones,
                                            phone.id,
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(
                                        _vm.selectedPhones,
                                        phone.id,
                                        $$c
                                      )
                                    }
                                  },
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(phone.display_phone))]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(phone.description))]),
                            _vm._v(" "),
                            _c("td", [
                              _vm.$AllProjects &&
                              _vm.$AllProjects[phone.site_id]
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$AllProjects[phone.site_id].name
                                      ) +
                                        " - " +
                                        _vm._s(
                                          _vm.$AllProjects[phone.site_id].title
                                        )
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm.$AllCities && _vm.$AllCities[phone.city_id]
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$AllCities[phone.city_id].short_name
                                      ) +
                                        " - " +
                                        _vm._s(
                                          _vm.$AllCities[phone.city_id].name
                                        )
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                          ]
                        )
                      }),
                      0
                    ),
                  ]),
                ])
              : _vm._e(),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("Менеджеры")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "управление доступами к номерам телефонов с которых возможно совершать исходящие звонки"
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "flex btns" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-info align-self-end",
          attrs: { type: "submit" },
        },
        [_vm._v("Поиск")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }